const lightTheme = {
  primary: "#5A8DF1",
  text: "#253858",
  textSecondary: "rgba(37, 56, 88, 0.7)",
  background: "rgba(255,255,255,1)",
  backgroundVariant: "rgba(251,249,249,1)",
  border: "rgba(37, 56, 88, 0.12)",
  borderLight: "rgba(37, 56, 88, 0.05)",
};

const darkTheme: Theme = {
  primary: "#5A8DF1",
  text: "rgba(241,233,231,1)",
  textSecondary: "rgba(241,233,231,0.6)",
  background: "rgba(0,0,0,1)",
  backgroundVariant: "rgba(28,26,26,1)",
  border: "rgba(241,233,231,0.15)",
  borderLight: "rgba(241,233,231,0.05)",
};

export type Theme = typeof lightTheme;

export const themes = {
  light: lightTheme,
  dark: darkTheme,
};
